import Count from '@/components/Count/index.vue';
import Edit from '@/components/Edit/index.vue';
/** 常用flex组件 */
import { Flexbox, FlexboxItem } from '@/components/flexbox';
import Footer from '@/components/Footer/index';
import { Header, newStoreHeader, StoreHeader } from '@/components/Header';
import LabelItem from '@/components/LabelItem';
import NoData from '@/components/NoData/index';
import NoPermissions from '@/components/NoPermissions/index';
import PublicTable from '@/components/PublicTable/index.vue';
import '@/icons'; // icon
import '@/styles/index.scss'; // global css
import { permDirective } from '@/utils/auth';
import '@/utils/filter'; // global filter
import SidebarItem from '@/views/layout/components/Sidebar/SidebarItem.vue';
// import { Checkbox, Menu, Tabs } from 'ant-design-vue';
import {
  Button,
  Checkbox,
  Form,
  Icon,
  Input,
  Menu,
  Modal,
  Spin,
  Tabs,
  Tooltip,
  Upload
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import 'codemirror/lib/codemirror.css';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n
import 'element-ui/lib/theme-chalk/index.css';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets
import VCharts from 'v-charts';
import Viser from 'viser-vue';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import VueCodemirror from 'vue-codemirror';
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import Prism from 'prismjs';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import Print from 'vue-printjs';
import App from './App';
import router from './router';
import store from './store';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
// 引入所有语言包
import hljs from 'highlight.js';
import mdEditor from '@/components/V-md-editor/index';


Vue.component('flexbox', Flexbox);
Vue.component('flexbox-item', FlexboxItem);
Vue.component('sidebar-item', SidebarItem);
Vue.component('app-header', Header);
Vue.component('store-header', StoreHeader);
Vue.component('public-table', PublicTable);
Vue.component('no-data', NoData);
Vue.component('no-permissions', NoPermissions);
Vue.component('app-footer', Footer);
Vue.component('count', Count);
Vue.component('label-item', LabelItem);
Vue.component('edit', Edit);
Vue.component('newStoreHeader', newStoreHeader); // 新的商店头部
Vue.use(Print);
Vue.use(Viser);
Vue.use(ElementUI, { locale });
Vue.use(VCharts);
Vue.use(VueClipboard);
Vue.use(VueCodemirror);
Vue.use(preview);
Vue.use(Input);
VueMarkdownEditor.use(vuepressTheme, {
  Prism
});
VueMarkdownEditor.use(githubTheme, {
  Hljs: hljs
});
Vue.use(VueMarkdownEditor);
Vue.component('MdEditor', mdEditor);

Vue.config.productionTip = false;
// antd ui
Vue.use(Tabs);
Vue.use(Menu);
Vue.use(Checkbox);
Vue.use(Tooltip);
Vue.use(Modal);
Vue.use(Button);
Vue.use(Form);
Vue.use(Spin);
Vue.use(Tabs);
Vue.use(Upload);
Vue.use(Icon);
Vue.directive('permit', {
  inserted: permDirective
});

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js